<template>
  <div>
    <div class="customerbox">
      <!-- <el-input v-model="CustomerAbbreviation" placeholder="选择单位" readonly /> -->
      <el-autocomplete
        ref="autocomplete"
        v-model="currentSearch"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入内容"
        @select="handleSelect"
        @blur="blurFun"
        style="flex: 1;margin-right:5px"
        :popper-append-to-body="false"
      ></el-autocomplete>
      <!--      @keyup.enter.native="enterFun" -->
      <!-- <el-button size="mini" type="primary" @click="onGoodsDialog"
        >请选择</el-button
      > -->
    </div>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
  </div>
</template>
<script>
import goodsDialog from "@/components/sales/business/listDialog";
export default {
  components: {
    goodsDialog,
  },
  props: {
    value: {},
    state: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentSearch: this.state,
      restaurants: [],
      timeout: null,
      api: require("@/api/goods/goods").default,
    };
  },
  watch:{
    state() {
      this.currentSearch = this.state;
    },
  },
  computed: {},
  methods: {
    enterFun(){
      if(this.restaurants.length>0){
        this.currentSearch=this.restaurants[0].Name
          let obj = {
            value:this.restaurants[0].Name,
            Id:this.restaurants[0].Id,
            Name:this.restaurants[0].Name
        }
        this.$emit('restaurants',obj)
         this.$refs.autocomplete.suggestions = [];
      }
    },
    onGoodsDialog() {
       this.$refs.goodsDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
      setGoods(cus) {
        this.currentSearch=cus.GoodsName
          let obj = {
            value:cus.GoodsName,
            Id:cus.GoodsId,
            Name:cus.GoodsName
        }
         this.$emit('restaurants',cus)
      },
    querySearchAsync(queryString, cb) {
      this.api.list({pageIndex: 1,pageSize: 10,GoodsName:queryString}).then((res) => {
       let arr=[]
       res.Data.forEach(e => {
         e.value=e.GoodsName
        arr.push(e)  
       });
       this.restaurants=arr
       var restaurants = this.restaurants;
       var results = restaurants
       cb(results);
      });
    },
    handleSelect(item) {
      this.$emit('restaurants',item)
    },
    blurFun(item){
      
      if(!this.currentSearch){
        let obj = {
            value:"",
            GoodsId:"",
            GoodsName:""
        }
        this.$emit('restaurants',obj)
        }
    },
  },
};
</script>
<style scoped>
::v-deep .el-autocomplete-suggestion{
  width: auto!important;
}
.customerbox {
  width: 100%;
  display: flex;
}

</style>